/**
 * 新菜单（字段与 Portal getAllMenuByMagazineIdAndUser 一致）
 * 接口只返回父级 colCode，子菜单在本地 children 中配置
 */

const ICONS = {
  nm0: require('@assets/img/nm0.png'),
  nm0_a: require('@assets/img/nm0_a.png'),
  nm1: require('@assets/img/nm1.png'),
  nm1_a: require('@assets/img/nm1_a.png'),
  nm2: require('@assets/img/nm2.png'),
  nm2_a: require('@assets/img/nm2_a.png'),
  nm3: require('@assets/img/nm3.png'),
  nm3_a: require('@assets/img/nm3_a.png'),
  nm4: require('@assets/img/nm4.png'),
  nm4_a: require('@assets/img/nm4_a.png'),
  nm5: require('@assets/img/nm5.png'),
  nm5_a: require('@assets/img/nm5_a.png'),
  nm6: require('@assets/img/nm6.png'),
  nm6_a: require('@assets/img/nm6_a.png')
}

/** 多级菜单子项 */
export const NEW_MENU_CHILDREN = {
  new_zdts: [
    {
      columnName: '工作桌面',
      index: '10-1',
      path: '/newActivePushDesktop',
      colCode: 'new_zdts_desktop'
    },
    {
      columnName: '邮件推送',
      index: '10-2',
      path: '/newActivePushEmail',
      colCode: 'new_zdts_email'
    },
    {
      columnName: '基础设置',
      index: '10-3',
      path: '/newActivePushSettings',
      colCode: 'new_zdts_settings'
    },
    {
      columnName: '报告下载',
      index: '10-4',
      path: '/newActivePushReport',
      colCode: 'new_zdts_report'
    }
  ],
  new_dyts: [
    {
      columnName: '订阅仪表盘',
      index: '11-1',
      path: '/newSubscribePushDashboard',
      colCode: 'new_dyts_dashboard'
    },
    {
      columnName: 'Email Alert订阅',
      index: '11-2',
      path: '/newSubscribePushEmailAlert',
      colCode: 'new_dyts_emailalert'
    },
    {
      columnName: '被引订阅',
      index: '11-3',
      path: '/newSubscribePushCited',
      colCode: 'new_dyts_cited'
    },
    {
      columnName: '模板配置',
      index: '11-4',
      path: '/citedPushTemplateConfig',
      colCode: 'new_dyts_templateconfig'
    }
  ],
  new_byts: [
    {
      columnName: '推送任务',
      index: '13-1',
      path: '/newCitedPushTask',
      colCode: 'new_byts_task'
    },
    {
      columnName: '数据看板',
      index: '13-2',
      path: '/newCitationStatsData',
      colCode: 'new_byts_dashboard'
    },
    {
      columnName: '模板配置',
      index: '13-3',
      path: '/citationStatsTemplateConfig',
      colCode: 'new_byts_templateconfig'
    }
  ]
}

function createMenu({
  id,
  index,
  columnName,
  path = '',
  colCode,
  iconKey,
  single
}) {
  const item = {
    id,
    index: String(index),
    columnName,
    path,
    colCode,
    icon: ICONS[iconKey],
    activeIcon: ICONS[`${iconKey}_a`],
    single
  }
  const children = NEW_MENU_CHILDREN[colCode]
  if (children) {
    item.title = columnName
    item.childrenList = children
  }
  return item
}

/** 按 colCode 索引的本地新菜单 */
export const NEW_MENU_MAP = {
  new_sjzl: createMenu({
    id: 'new_sjzlM',
    index: '9',
    columnName: '数据综览',
    path: '/newDataOverview',
    colCode: 'new_sjzl',
    iconKey: 'nm0',
    single: true
  }),
  new_zdts: createMenu({
    id: 'new_zdtsM',
    index: '10',
    columnName: '主动推送',
    colCode: 'new_zdts',
    iconKey: 'nm1',
    single: false
  }),
  new_dyts: createMenu({
    id: 'new_dytsM',
    index: '11',
    columnName: '订阅推送',
    colCode: 'new_dyts',
    iconKey: 'nm2',
    single: false
  }),
  new_wxts: createMenu({
    id: 'new_wxtsM',
    index: '12',
    columnName: '微信推送',
    path: '/newWeChatPush',
    colCode: 'new_wxts',
    iconKey: 'nm3',
    single: true
  }),
  new_byts: createMenu({
    id: 'new_bytsM',
    index: '13',
    columnName: '被引推送',
    colCode: 'new_byts',
    iconKey: 'nm4',
    single: false
  }),
  new_yztj: createMenu({
    id: 'new_yztjM',
    index: '14',
    columnName: '引证统计',
    path: '/newCitationStats',
    colCode: 'new_yztj',
    iconKey: 'nm5',
    single: true
  }),
  new_yhfx: createMenu({
    id: 'new_yhfxM',
    index: '15',
    columnName: '用户分析',
    path: '/newUserAnalysis',
    colCode: 'new_yhfx',
    iconKey: 'nm6',
    single: true
  })
}

export const NEW_MENU_LIST = Object.values(NEW_MENU_MAP)
